
<div class="template-selector">
  <div class="badgebutton-group">
    <button class="badgebutton active text-center" @click="$emit('add-blank')">
      <i class="far fa-plus"></i>
      Add new Task
    </button>
    <button
      class="badgebutton active text-center"
      @click="toggleDropdown"
      ref="dropdownToggle"
    >
      <i class="far fa-caret-down"></i>
    </button>
  </div>

  <div v-show="isOpen" class="template-dropdown" ref="dropdown">
    <div class="dropdown-header">
      <div class="search-container">
        <i class="far fa-search search-icon"></i>
        <input
          type="text"
          v-model="searchQuery"
          placeholder="Search templates..."
          class="search-input"
          ref="searchInput"
          @keydown.enter="handleEnter"
          @keydown.escape="closeDropdown"
        />
      </div>
    </div>

    <div class="dropdown-content">
      <!-- No templates message -->
      <div v-if="!hasAnyTemplates" class="no-templates">
        <i class="far fa-2x fa-sticky-note"></i>
        <br />
        There are no templates for this board available.
      </div>

      <!-- Search results (flat list) -->
      <div v-else-if="searchQuery" class="search-results">
        <div v-if="!filteredTemplates.length" class="no-results">
          No templates found matching "{{ searchQuery }}"
        </div>
        <div
          v-for="template in filteredTemplates"
          :key="template.id"
          class="template-item"
          @click="selectTemplate(template.id)"
        >
          <i class="far fa-file-alt template-icon"></i>
          <span class="template-title">{{ template.title }}</span>
          <span class="click-hint">click to add</span>
        </div>
      </div>

      <!-- Categorized view -->
      <div v-else class="category-list">
        <!-- Flat list when only uncategorized templates -->
        <template v-if="hasOnlyUncategorized">
          <div
            v-for="templateItem in categoryGroups[0].templates"
            :key="templateItem.template.id"
            class="template-item"
            @click="selectTemplate(templateItem.template.id)"
          >
            <i class="far fa-file-alt template-icon"></i>
            <span class="template-title">{{ templateItem.template.title }}</span>
            <span class="click-hint">click to add</span>
          </div>
        </template>

        <!-- Category groups with hover submenus -->
        <template v-else>
          <div
            v-for="(group, index) in categoryGroups"
            :key="group.category ? group.category.guid : 'uncategorized'"
            class="category-group"
            :ref="'category-' + index"
            @mouseenter="onCategoryHover(group, index, $event)"
            @mouseleave="onCategoryLeave"
          >
            <div class="category-header">
              <i v-if="group.category && group.category.icon" :class="group.category.icon" class="category-icon"></i>
              <i v-else class="far fa-folder category-icon"></i>
              <span class="category-name">{{ group.category ? group.category.name : 'Uncategorized' }}</span>
              <i class="far fa-chevron-right expand-icon"></i>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>

  <!-- Floating submenu rendered outside the dropdown -->
  <div
    v-if="expandedCategory && expandedCategoryTemplates.length > 0"
    class="template-submenu-wrapper"
    :style="submenuStyle"
    @mouseenter="submenuHovered = true"
    @mouseleave="onSubmenuLeave"
  >
    <div class="template-submenu">
      <div
        v-for="templateItem in expandedCategoryTemplates"
        :key="templateItem.template.id"
        class="template-item"
        @click="selectTemplate(templateItem.template.id)"
      >
        <i class="far fa-file-alt template-icon"></i>
        <span class="template-title">{{ templateItem.template.title }}</span>
        <span class="click-hint">click to add</span>
      </div>
    </div>
  </div>
</div>
